/**
 * Status filter + Refresh above a client order list — shared by the Orders,
 * Recurring orders and Mandate orders tabs. `"all"` means no filter.
 */

export const T = {
  en_GB: { refresh: "Refresh", filterAll: "All statuses" },
  nb_NO: { refresh: "Oppdater", filterAll: "Alle statuser" },
} as const;
